import socket from './index'

export function connectSocket(token) {
    if (socket.connected) {
        return socket;
    }

    socket.auth = {
        token
    };

    socket.connect();

    return socket;
}

export function disconnectSocket() {
    socket.disconnect();
}